import React from 'react';
import PropTypes from 'prop-types';

class DateRange extends React.Component {

  static propTypes = {
    onSelectCallback: PropTypes.func,
  }

  constructor(props) {
    super(props);
    const dateRange = new Monet.UI.Fields.DateRange();
    const startDate = Monet.Format.Date.getTodayISOString({ daysOffset: -2 });
    const endDate = Monet.Format.Date.getTodayISOString();
    this.state = {
      visible: false,
      dateRange,
      startDate,
      endDate,
    };
  }

  componentDidMount() {
    const { dateRange, startDate, endDate } = this.state;
    const el = dateRange.render({
      onSelectCallback: this.onSelectCallback.bind(this),
    });
    this.refs.dateRange.appendChild(el);
    dateRange.setValue({ ini: startDate, fin: endDate });
  }

  componentDidUpdate() {
    const { dateRange, visible, startDate, endDate } = this.state;
    if (visible) {
      dateRange.setValue({ ini: startDate, fin: endDate });
    } else {
      dateRange.setValue({ ini: '', fin: '' });
    }
    return true;
  }

  onSelectCallback = () => {
    const { onSelectCallback } = this.props;
    const { ini: startDate, fin: endDate } = this.state.dateRange.getValue();
    const [startDateToShow, endDateToShow] = this.checkDates([startDate, endDate]);

    this.setState({
      ...this.state,
      startDate: startDateToShow,
      endDate: endDateToShow,
    });
    onSelectCallback(startDateToShow, endDateToShow);
  }

  updateState(visible) {
    this.setState({
      ...this.state,
      visible,
    });
  }

  checkDates(datesChanged) {
    const datesToShow = datesChanged.map( (date, index) => {
      if(this.testIfIsADateOrInvalidDate(date)) {
        return date;
      } else {
        const startOrEndDate = (index === 0 ? "startDate" : "endDate");
        return this.state[startOrEndDate];
      }
    });

    return datesToShow;
  }

  testIfIsADateOrInvalidDate = function(valueFormated) {
    const regTestIfIsValidDate = /\-[0-9]/g;
    if (((valueFormated.match(regTestIfIsValidDate)) || (valueFormated === ''))) {
        return true;
    } else {
        return false;
    }
  }

  render() {
    const display = (this.state.visible) ? 'inline-flex' : 'none';
    const styles = {
      display,
      width: '100%'
    };

    return (
      <div ref="dateRange" style={styles} />
    );
  }
}

export default DateRange;
